import { axios, Response } from '../index'
import { PostView } from './get-post-by-id'

type Body = {
  personaId: string
  postId: number
}

const tagAsViewed = (body: Body): Response<PostView> => {
  return axios.post('/v1/views/', body)
}

export default tagAsViewed
